import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';
import { useCurrentUserRole } from '../../shared/session/useCurrentUserRole';
import { APP_SHELL_ROUTE_PREFIX, getDefaultRouteForRole } from './routeManifest';
import { useIsPWA } from '../../shared/lib/pwaUtils';
import { usesCentralIdentity } from '../../features/auth/sessionAccess';
import TenantAccessRejected, {
  isTenantAccessRejection,
} from '../../features/auth/components/TenantAccessRejected';

export function PublicRoute({ children }) {
  const { isAuthenticated, initialized } = useAuth();
  const {
    data: userRole,
    error: roleError,
    isLoading: isRoleLoading,
  } = useCurrentUserRole({ enabled: isAuthenticated });
  const { pathname } = useLocation();
  const isPWA = useIsPWA();

  const publicOnlyPaths = ['/login', '/'];

  if (isAuthenticated && usesCentralIdentity() && isTenantAccessRejection(roleError)) {
    return <TenantAccessRejected />;
  }

  if (!initialized || (isAuthenticated && isRoleLoading)) {
    return null;
  }

  if (isPWA && !isAuthenticated && pathname === '/') {
    return <Navigate to="/login" replace />;
  }

  if (isAuthenticated && publicOnlyPaths.includes(pathname)) {
    const redirectTo = userRole ? getDefaultRouteForRole(userRole) : APP_SHELL_ROUTE_PREFIX;
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
